import React from 'react';

import './CircularLoader.scss';

function CircularLoader(props) {
  const {
    style,
    size = 10,
    thickness = 5,
    color = '#357BFF',
    backgroundColor = 'rgba(0, 0, 0, 0)',
  } = props;

  const handledSize = size - 2 * thickness;

  return (
    <div
      className="circular-loader"
      style={{
        width: handledSize,
        height: handledSize,
        border: `${thickness}px solid ${backgroundColor}`,
        borderLeftColor: color,
        ...style,
      }}
    />
  );
}

export default CircularLoader;
